import SetupLicense from './SetupLicense'

export default SetupLicense
